var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 9.75h-1.5a2.25 2.25 0 00-2.25-2.25V6A3.75 3.75 0 0118 9.75z","key":0}),React.createElement("path",{"d":"M21 9.75h-1.5a5.26 5.26 0 00-5.25-5.25V3A6.76 6.76 0 0121 9.75zM19.5 21.75h-.13C4.63 20.9 2.54 8.47 2.25 4.67A2.25 2.25 0 014.5 2.25h3.95a1.5 1.5 0 011.4.94L10.99 6a1.5 1.5 0 01-.33 1.62l-1.6 1.61a7.02 7.02 0 005.68 5.7l1.63-1.61a1.5 1.5 0 011.63-.3l2.83 1.13a1.5 1.5 0 01.92 1.39v3.96a2.25 2.25 0 01-2.25 2.25zm-15-18a.75.75 0 00-.75.81C4.09 9 6.31 19.5 19.45 20.25a.75.75 0 00.8-.7v-4.01l-2.83-1.13-2.15 2.14-.36-.05C8.38 15.68 7.5 9.16 7.5 9.09l-.04-.36 2.13-2.15-1.13-2.83H4.5z","key":1})]);
}

IconPhone.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
